import LegalPage from "./LegalPage";

const SECTIONS = [
  {
    heading: "Introduction",
    body: [
      "Adinvo (\"we\", \"us\", \"our\") is a performance marketing and branding agency based in Mumbai, India. This Privacy Policy explains how we collect, use, and protect the information you share with us when you visit our website, submit an enquiry, or book an appointment.",
      "By using our website and services, you agree to the practices described in this policy.",
    ],
  },
  {
    heading: "Information We Collect",
    body: [
      "We collect information you voluntarily provide through our contact and booking forms, including your name, email address, phone or WhatsApp number, selected service, preferred appointment date and time, and any message or notes you share.",
      "We may also automatically collect limited technical data such as browser type, device information, and usage analytics to improve our website experience.",
    ],
  },
  {
    heading: "How We Use Your Information",
    body: [
      "Your information is used to respond to your enquiries, schedule and manage appointments, deliver our services, and communicate relevant updates.",
      "We do not sell or rent your personal information to third parties. We may share limited data with trusted service providers (such as scheduling or communication tools) strictly to operate our services.",
    ],
  },
  {
    heading: "Data Retention & Security",
    body: [
      "We retain your information only for as long as necessary to fulfil the purposes described here or as required by law. We apply reasonable technical and organisational measures to protect your data against unauthorised access, loss, or misuse.",
    ],
  },
  {
    heading: "Your Rights",
    body: [
      "You have the right to access, correct, or request deletion of your personal information. To exercise these rights, contact us via WhatsApp, phone, or our contact form and we will respond within a reasonable timeframe.",
    ],
  },
  {
    heading: "Cookies & Analytics",
    body: [
      "Our website may use cookies and similar technologies to understand how visitors interact with our content. You can control cookies through your browser settings.",
    ],
  },
  {
    heading: "Changes to This Policy",
    body: [
      "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      title="Privacy Policy"
      updated="December 2025"
      sections={SECTIONS}
    />
  );
}
